import styled from 'styled-components';

import AlertBox from './AlertBox';

const StyledAlertBox = styled(AlertBox)`
    background-color: ${(props) => props.theme.colours.errorBackground};
    color: ${(props) => props.theme.colours.errorColor};
    border: 1px solid ${(props) => props.theme.colours.errorBorder};
    border-radius: ${(props) => props.theme.corners.box.outside}px;
    padding: 20px;
`;

export default StyledAlertBox;
